export default "__VITE_ASSET__DkpkWDtA__"